import styles from './ActionButtonIcon.module.scss'

type Props = {
  readonly icon: React.ReactNode
}

export const ActionButtonIcon = ({ icon }: Props) => {
  return <span className={styles.icon}>{icon}</span>
}
